// ── Button sx constants ───────────────────────────────────────────────────────
// Shared by ActionButtons.jsx and submissionDynamicform.js.
// Values reference CSS variables from partials/_fs-variables.css — the design
// tokens remain a single source of truth; nothing is hardcoded here.
export const BTN_SX = {
  // "Save & Close" / "Submit" — secondary neutral button
  saveClose: {
    background: 'var(--background-color)',
    border: 'none',
    boxShadow: 'none',
    width: 107, minWidth: 107, height: 36,
    padding: '0 10px', borderRadius: '6px',
    color: 'var(--color-text-dark)',
    fontWeight: 400, fontSize: 12,
    fontFamily: 'var(--fs-font-primary)',
    lineHeight: '20px', letterSpacing: 0,
    textTransform: 'none',
    '&:hover': {
      background: 'var(--secondary-color)',
      border: '1px solid var(--primary-color)',
    },
  },
  // "Save & New" / "Next" — primary gradient action button
  saveNew: {
    width: 100, minWidth: 100, height: 36,
    borderRadius: '6px', padding: '0 10px',
    border: 'none', boxShadow: 'none', flexShrink: 0,
    background: 'linear-gradient(to bottom, color-mix(in srgb, var(--primary-color) 75%, white 25%), color-mix(in srgb, var(--primary-color) 85%, black 15%))',
    fontSize: 12, fontWeight: 400,
    fontFamily: 'var(--fs-font-primary)',
    lineHeight: '20px', color: 'var(--fs-color-white)',
    letterSpacing: 0, textTransform: 'none',
    '&:hover': {
      background: 'linear-gradient(to bottom, color-mix(in srgb, var(--primary-color) 65%, white 35%), color-mix(in srgb, var(--primary-color) 75%, black 25%))',
    },
  },
  // First-level "Reject" — outlined neutral
  rejectOutlined: {
    background: 'var(--fs-color-white)', border: '1px solid var(--color-border)',
    boxShadow: 'none', width: 97, minWidth: 97, height: 36,
    color: 'var(--color-text-dark)', fontSize: 12, lineHeight: '20px',
    fontWeight: 400, borderRadius: '6px', padding: '0 10px',
    ml: '5px', textTransform: 'none',
    '&:hover': {
      background: 'var(--fs-color-bg-hover)',
      borderColor: 'var(--fs-color-border-hover)',
      color: 'var(--fs-color-text-hover)',
    },
  },
  // First-level "Approve" — outlined neutral
  approveOutlined: {
    background: 'var(--fs-color-white)', border: '1px solid var(--color-border)',
    boxShadow: 'none', padding: '0 10px',
    width: 110, minWidth: 110, height: 36,
    borderRadius: '6px', color: 'var(--color-text-dark)',
    fontSize: 12, fontWeight: 400, lineHeight: '20px', textTransform: 'none',
    '&:hover': {
      background: 'var(--fs-color-bg-hover)',
      borderColor: 'var(--fs-color-border-hover)',
      color: 'var(--fs-color-text-hover)',
    },
  },
  // "Previous" — outlined light navigation (bottom bar)
  previous: {
    color: 'var(--color-text-muted)', fontWeight: 600,
    fontFamily: 'var(--fs-font-nav)', borderRadius: '8px',
    border: '1px solid var(--color-border)', background: 'var(--fs-color-white)',
    boxShadow: 'none', textTransform: 'none', minWidth: 'unset',
  },
  // Delete IconButton
  deleteIcon: {
    ml: 1, color: 'var(--primary-color)',
    '&:hover': { backgroundColor: 'var(--background-color)' },
  },
};
